import { Users, Activity, KeyRound, TrendingUp } from "lucide-react";

const fmtRate = (v) => (v === null || v === undefined ? "—" : `${v}%`);

export const PortalStats = ({ stats }) => {
  const cards = [
    { key: "total", label: "Total Referrals", value: stats.total, icon: Users, tone: "text-[#0A2342]" },
    { key: "active", label: "Active Referrals", value: stats.active, icon: Activity, tone: "text-[#0F6E6E]" },
    { key: "leased", label: "Leased", value: stats.leased, icon: KeyRound, tone: "text-emerald-600" },
    { key: "success", label: "Success Rate", value: fmtRate(stats.success_rate), icon: TrendingUp, tone: "text-[#C8A96B]" },
  ];
  return (
    <section className="max-w-5xl mx-auto px-5 -mt-6 md:-mt-8 relative z-10" data-testid="portal-stats">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {cards.map((c) => (
          <div key={c.key} className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 md:p-5" data-testid={`portal-stat-${c.key}`}>
            <div className="flex items-center justify-between">
              <span className="text-[11px] uppercase tracking-wide text-slate-500 font-semibold">{c.label}</span>
              <c.icon className={`w-4 h-4 ${c.tone}`} />
            </div>
            <div className={`mt-2 text-2xl md:text-3xl font-bold ${c.tone}`} data-testid={`portal-stat-${c.key}-value`}>{c.value}</div>
          </div>
        ))}
      </div>
    </section>
  );
};
